import { render } from "./SheetPage.vue?vue&type=template&id=4bb1bb33&scoped=true"
import script from "./SheetPage.vue?vue&type=script&lang=js"
export * from "./SheetPage.vue?vue&type=script&lang=js"

import "./SheetPage.vue?vue&type=style&index=0&id=4bb1bb33&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb1bb33"]])

export default __exports__